import {queryBearerToken} from "./UserAuthentication";
import * as ActionTypes from "../constants/ActionTypes";
import {queryArticleOptionData, queryBaseArticle} from "./ArticleData";
import {queryNewCartFromTemplate} from "./Cart";
import {queryTopLevelDomains} from "./Domain";
import {queryPromotionCodeInit} from "./PromotionCode";
import {initialize as initializeForms} from "redux-form";
import {appInitialized} from "./AppInit";
import {getSoftwareLoaders} from "./AppInit.SoftwareLoaders";
import {getArticleOptionsData, getCart, getCartBackupRange, getCartCommissionValue, getCartPromotionCode} from "../selectors/SimpleSelectors";
import {getArticleOptionsInCartList} from "../selectors/CartUtil";
import {selectBaseArticle} from "./BaseArticle";
import {selectCartProperty} from "./Properties";
import {ARTICLE_TYPE_BASE, PROJECT_STATE_LIVE} from "../constants/General";
import {getConsumerArticlesInCartSplit} from "../selectors/ProjectSelection";
import {agencyServerArticleNumber} from "../config/Config";

export const initializeAppWithPreset = (baseArticleId, initParams) => (dispatch, getState) => {

    const {createdFromPreset} = initParams

    Promise.all([
        dispatch(queryBearerToken())
    ]).then((args) => {
        if (args[0].type !== ActionTypes.BEARER_TOKEN_FAILURE) {

            const initialCalls = [
                queryBaseArticle(baseArticleId),
                queryNewCartFromTemplate(createdFromPreset),
                queryTopLevelDomains()
            ]

            Promise.all(initialCalls.map(func => dispatch(func))).then((args) => {
                if (args[0].type === ActionTypes.BASE_ARTICLE_SUCCESS
                    && args[1].type === ActionTypes.CART_CREATE_SUCCESS
                    && args[2].type === ActionTypes.TOPLEVELDOMAINS_SUCCESS) {

                    dispatch({
                        type: ActionTypes.BASE_ARTICLE_LOAD_COMPLETE
                    })

                    Promise.all([
                        ...getSoftwareLoaders(getState().articleData.baseArticle.type).map(func => dispatch(func)),
                        // iterate through articleOptions and load data if price not available
                        queryArticleOptionData(Object.keys(getState().articleData.articleOptions).filter(key => getState().articleData.articleOptions[key].price ? null : key).join(","))
                    ]).then((args) => {


                        // verify cart items
                        const articleOptionData = getArticleOptionsData(getState())
                        getArticleOptionsInCartList(getState()).forEach(articleOptionNumber => {

                            const articleData = articleOptionData[articleOptionNumber]

                            // if initial storage option, save value

                            if (!articleData) {
                                alert("Ungültiger Warenkorbinhalt!")
                            } else {
                                if (articleData.title && articleData.title.indexOf("GB") >= 0) {

                                    //const regex = /(\d{1,})/
                                    //const minSelectedUsageGB = regex.exec(articleData.title)[1];

                                    //initParams = {...initParams, minSelectedUsageGB}

                                }
                            }
                        })

                        if (getCartPromotionCode(getState())) {
                            dispatch(queryPromotionCodeInit())
                            dispatch(initializeForms('promotionCodeForm',
                                {
                                    promotionCode: getCartPromotionCode(getState())
                                }
                            ))
                        }

                        if (getCart(getState()) && getCart(getState()).backupRange) {
                            dispatch(selectCartProperty("backupRange", getCart(getState()).backupRange, false));
                        }

                        if (getCartCommissionValue(getState())) {
                            dispatch(initializeForms('commissionForm',
                                {
                                    commission: getCartCommissionValue(getState())
                                }
                            ))
                        }

                        /*if (getCart(getState()) && getCart(getState()).backupRange) {
                            dispatch(selectCartProperty("backupRange", getCart(getState()).backupRange));
                        }*/

                        if (("" + baseArticleId) !== agencyServerArticleNumber) {
                            const consumerArticlesInCart = getConsumerArticlesInCartSplit(getState());

                            const initialValues = {
                                article: "" + baseArticleId,
                                storage: consumerArticlesInCart.storage.length > 0 ? consumerArticlesInCart.storage[0].articleNumber : "",
                                backup: getCartBackupRange(getState()) || 7,
                                type: ARTICLE_TYPE_BASE,
                                state: PROJECT_STATE_LIVE
                            }

                            dispatch(initializeForms('projectSelection', initialValues))
                        }

                        // no client data in preset...

                        //dispatch(selectLatestValidStep())

                        dispatch(selectBaseArticle(baseArticleId))

                        // app initialized
                        dispatch(appInitialized(initParams))
                    })
                }
            })
        }
    })
}



/** WEBPACK FOOTER **
 ** ./src/actions/AppInit.WithPreset.js
 **/